export default __webpack_public_path__ + "static/media/shared.33d476a6.svg";